import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const PregnantWomenEarlyPrenatalCapture = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={'Indice de Gestantes com Captura Precoce no Pré-Natal'}
            indicatorValue={
                chartData?.indicators?.pregnantWomenEarlyPrenatalCapture
            }
            className="aligned-container"
            goalValue={45}
            goalMessage="Meta Aceitável - acima de 45%"
        />
    );
};
